import React from 'react';
import { Typography } from '@mui/material';
import Dinero from 'views/rebranded-module/common/utils/Dinero';
import moneyFormat from 'views/rebranded-module/common/utils/moneyFormat';
import { useTranslation } from 'next-i18next';
import StyledBox from 'views/VehicleModelView/components/RateRangesComponent/RateRangesComponent.styles';

const RateRangesComponent = (props) => {
  const { rateRanges } = props;
  const { t } = useTranslation('fe_er_vehicle_model_page');

  return (
    <StyledBox>
      <div className="mdr-moreDiscountWrapper">
        {rateRanges.map((rateRange) => (
          <div className="mdr-info" key={rateRange.rate}>
            <div>
              <Typography variant="h5" component="span" className="mdr-price">
                {moneyFormat(Dinero(rateRange.rate))}
              </Typography>
              <Typography component="span" className="mdr-per mdr-grey300">
                {t('fe_er_vehicle_model_page:per_day')}
              </Typography>
            </div>
            <Typography className="mdr-smallText mdr-grey300">
              {`${rateRange.start_day}${
                rateRange.end_day ? `-${rateRange.end_day}` : '+'
              } `}
              {t('fe_er_vehicle_model_page:days')}
            </Typography>
          </div>
        ))}
      </div>
    </StyledBox>
  );
};

export { RateRangesComponent };
